import React, { useState } from 'react';
import EditMyIntroModal from "./editProfileModals/EditMyIntroModal";
import EditMyPhotoModal from "./editProfileModals/EditMyPhotoModal";
import MyProfileCompletion from './MyProfileCompletion';
import MyVideo from './MyVideo';
import me from '../../assets/me.JPG';
import {
    BrowserRouter as Router, Switch, Route, Link , useHistory
  } from "react-router-dom";

function MyIntroduction(props) {
    const [ myPhotoModal, setMyPhotoModal ] = useState(false);
    const toggleMyPhotoModal = () => setMyPhotoModal(!myPhotoModal);
    const [ myIntroModal, setMyIntroModal ] = useState(false);
    const toggleMyIntroModal = () => setMyIntroModal(!myIntroModal);   
     
    var { store } = props
    var { profile } = store
    var { basic } = profile

    var history = useHistory();
    const onNavigate = (o) => {
      history.push(o)
    }
    return (
    <div className="row pd-l-5">
        <div className="wd-pct-33 pd-r-0">
            <div className="profile-card b-l-border b-t-border b-b-border">
                <div className="row pd-20">
                    <img alt="EAI" src={me} style={{height: '160px'}} className="img-radius-50 pd-l-5 c-pointer" onClick={toggleMyPhotoModal} />                            
                    <EditMyPhotoModal modal={myPhotoModal} toggle={toggleMyPhotoModal} basic={basic} />
                    <div className=" pd-r-25">
                        <div className="category-box-content mg-l-20 pd-t-45">
                            <h3>{basic.fName} {basic.mName} {basic.sName}</h3>
                            <p>{basic.headline}</p>
                            <div className="profile-location">{basic.city + ", " + basic.country}</div>
                        </div>
                    </div>
                </div>
                        <div className="row transaction-footer">                        
                            <div className="col-md-6 b-t-border b-r-border " onClick={() => onNavigate("viewprofile")}>
                            View Profile
                            </div>
                            <div className="col-md-6 b-t-border" onClick={() => onNavigate("resume")}>Build Resume</div>                            
                        </div>
                    </div>
        </div>
        <div className="wd-pct-27 pd-l-0">
                    <div className="profile-card-dark">
                        <div className="profile-card-dark-header">
                            <div className="profile-card-dark-header-left">
                                <h5>Cover Message</h5>
                            </div>                        
                            <div className="profile-card-dark-header-right">
                                <i className="far fa-edit" onClick={toggleMyIntroModal} ></i>
                                <EditMyIntroModal modal={myIntroModal} toggle={toggleMyIntroModal} basic={basic} />                             
                            </div>
                        </div>
                        <div className="profile-card-dark-block p-t-0">
                            {basic.coverMsg}
                        </div>
                    </div>
        </div>
        <div className="wd-pct-1"></div>
        <div className="wd-pct-20">
        <MyVideo />
            
        </div>
        <div className="wd-pct-1"></div>
        <div className="wd-pct-18">
        <MyProfileCompletion />
            
        </div>
    </div>
        
    );
  }

export default MyIntroduction